import React from "react";
import logo from './loho.png';

const Oteatrze = () => {
    return (
        <div className="w-full bg-[#0d0d0d] py-16 flex flex-col items-center text-white">
            <img src={logo} className="h-52 w-52 mb-6 opacity-90" alt="Logo Teatr Łątek" />
            <div className="text-center">
                <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-extrabold tracking-widest uppercase mb-3">
                    Teatr Łątek
                </h1>
                <div className="w-16 h-px bg-red-500 mx-auto mb-4" />
                <h2 className="text-base sm:text-lg md:text-xl text-gray-400 tracking-widest uppercase">
                    Najmniejszy teatr w Polsce
                </h2>
            </div>
        </div>
    );
};

export default Oteatrze;
